// extracted by mini-css-extract-plugin
module.exports = {"title":"ProductDetailsAccordion_title__U9D21","description":"ProductDetailsAccordion_description__0BH4H"};